import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Input } from '../../index.js';
const Update = (props) => {
    const lang = useSelector((s) => s.lang);
    const [password, setPassword] = useState('');
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                e.stopPropagation();
                props.onUpdate(password);
            } },
            React.createElement("p", null, lang.login.newPasswordExplainer),
            React.createElement(Input, { type: "password", placeholder: lang.login.newPasswordPlaceholder, onChange: (e) => {
                    setPassword(e.target.value);
                } }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' } }, lang.login.updatePassword),
            React.createElement(Button, { block: true, onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onCancel();
                }, theme: "secondary" }, lang.misc.cancel))));
};
export default Update;
//# sourceMappingURL=Update.js.map